import type { TestStepProps } from 'src/suitability/engine/types';
import { BLOCK1_QUESTIONS, type LiftAnswers } from './answers';
import { ScoredBlock } from './scored-block';

/** Bloque 1 — conocimientos y experiencia inversora. Doce preguntas, sin reglas. */
export const StepBlock1 = (props: TestStepProps<LiftAnswers>) => (
  <ScoredBlock {...props} stepKey="block1" questions={BLOCK1_QUESTIONS} />
);
